import { render, staticRenderFns } from "./ReserveProduct.vue?vue&type=template&id=18529b13&"
import script from "./ReserveProduct.vue?vue&type=script&lang=js&"
export * from "./ReserveProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports